import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      {/* Header */}
      <header className="bg-[#00124a] py-6">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-white hover:text-[#3c68ff] transition-colors text-sm">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#00124a] mb-8">Terms of Service</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            <strong>Effective Date:</strong> January 1, 2025
          </p>

          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            Welcome to Amplify HR Management, LLC ("Amplify," "we," "us," or "our"). By accessing or using our website and services, you agree to be bound by these Terms of Service ("Terms"). Please read them carefully.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">1. Acceptance of Terms</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            By accessing our website at success.goamplifypeo.com or any related sites, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please do not use our website or services.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">2. Description of Services</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            Amplify is an IRS Certified Professional Employer Organization (PEO) and ESAC Accredited company that provides comprehensive HR solutions including payroll processing, benefits administration, tax compliance, workers' compensation, and HR management services. Our website provides information about our services and allows potential clients to request more information.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">3. Use of Website</h2>
          <p className="text-[#4A5568] mb-4 text-base leading-relaxed">
            You agree to use our website only for lawful purposes and in accordance with these Terms. You agree not to:
          </p>
          <ul className="list-disc pl-6 mb-6 text-[#4A5568] space-y-2">
            <li>Use the website in any way that violates applicable laws or regulations</li>
            <li>Attempt to gain unauthorized access to any portion of the website</li>
            <li>Use any automated means to access the website or collect information</li>
            <li>Interfere with or disrupt the website or servers</li>
            <li>Transmit any viruses, malware, or other harmful code</li>
          </ul>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">4. Intellectual Property</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Amplify HR Management, LLC or its content suppliers and is protected by United States and international copyright laws. The compilation of all content on this site is the exclusive property of Amplify. "PrevantEdge" is a trademark of Amplify HR Management, LLC.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">5. Information Accuracy</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            While we strive to provide accurate and up-to-date information, the content on this website is provided for general informational purposes only. All scenarios, visuals, and descriptions related to benefits programs (including PrevantEdge™) are illustrative and presented for informational purposes only. Actual benefits, coverage levels, and savings vary by group and are subject to plan terms, conditions, and underwriting.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">6. No Professional Advice</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            The information provided on this website does not constitute legal, tax, financial, or professional advice. You should consult with appropriate professionals before making any business decisions based on information from this website.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">7. Third-Party Links</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            Our website may contain links to third-party websites or services that are not owned or controlled by Amplify. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">8. Limitation of Liability</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            TO THE FULLEST EXTENT PERMITTED BY LAW, AMPLIFY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE WEBSITE OR SERVICES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU, IF ANY, FOR ACCESSING THE WEBSITE.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">9. Indemnification</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            You agree to defend, indemnify, and hold harmless Amplify and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or in any way connected with your access to or use of the website.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">10. Modifications to Terms</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page. Your continued use of the website after any such changes constitutes your acceptance of the new Terms.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">11. Governing Law</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            These Terms shall be governed by and construed in accordance with the laws of the State of Illinois, without regard to its conflict of law provisions. Any disputes arising under these Terms shall be resolved in the state or federal courts located in Illinois.
          </p>

          <h2 className="text-xl font-bold text-[#00124a] mt-8 mb-4">12. Contact Information</h2>
          <p className="text-[#4A5568] mb-6 text-base leading-relaxed">
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <div className="bg-white rounded-lg p-6 border border-[#e2e8f0]">
            <p className="text-[#00124a] font-bold mb-2">Amplify HR Management, LLC</p>
            <p className="text-[#4A5568]">Email: <a href="mailto:success@amplifyhrm.com" className="text-[#3c68ff] hover:underline">success@amplifyhrm.com</a></p>
            <p className="text-[#4A5568]">Phone: <a href="tel:8558088689" className="text-[#3c68ff] hover:underline">(855) 808-8689</a></p>
            <p className="text-[#4A5568]">Website: <a href="https://amplifyhrm.com" className="text-[#3c68ff] hover:underline">amplifyhrm.com</a></p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#00124a] py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-[#6B7280] text-sm">
            © {new Date().getFullYear()} Amplify HR Management, LLC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
